var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tag-select-search',{attrs:{"selectedTags":_vm.selectedTags,"unselectedTags":_vm.unselectedTags},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }